<section *ngIf="hasPartnerAlerts && !hasExtPartnerPortfolioAlerts" class="partner-alerts-container text-14 padding-top-5">
	<pi-alert *ngIf="isModelDirty" [text]="AlertConstants.PORTFOLIO_ALTERED_ALERT_TEXT | dcr : 'PORTFOLIO_ALTERED_ALERT_TEXT'" [infoBubble]="portfolioAlteredInfoBubble">
	</pi-alert>
	<pi-alert
		*ngIf="hasReallocatedSecurities"
		[text]="AlertConstants.ALERT_REALLOCATED_SECURITIES_TEXT | dcr : 'ALERT_REALLOCATED_SECURITIES_TEXT'"
		[infoBubble]="alertReallocatedSecuritiesInfoBubble"
	>
	</pi-alert>
	<pi-alert
		*ngIf="hasCashSubstitutions"
		[text]="AlertConstants.ALERT_CASH_SUBSTITUTIONS_TEXT | dcr : 'ALERT_CASH_SUBSTITUTIONS_TEXT'"
		[infoBubble]="alertCashSubstitutionsInfoBubble"
	>
	</pi-alert>
	<pi-alert
		*ngIf="hasAssetClassSubstitutions || hasBondSubstitutions"
		[text]="AlertConstants.ALERT_ASSET_CLASS_OR_BOND_SUBSTITUTIONS_TEXT | dcr : 'ALERT_ASSET_CLASS_OR_BOND_SUBSTITUTIONS_TEXT'"
		[infoBubble]="AlertConstants.ALERT_ASSET_CLASS_OR_BOND_SUBSTITUTIONS_INFO | dcr : 'ALERT_ASSET_CLASS_OR_BOND_SUBSTITUTIONS_INFO'"
	>
	</pi-alert>
</section>
<section *ngIf="hasExtPartnerPortfolioAlerts" class="partner-alerts-container text-14 padding-top-5">
	<pi-alert
		[text]="AlertConstants.EXT_PARTNER_PORTFOLIO_ALTERED_ALERT_TEXT | dcr : 'EXT_PARTNER_PORTFOLIO_ALTERED_ALERT_TEXT'"
		[infoBubble]="extPartnerPortfolioAlteredInfoBubble"
	></pi-alert>
	<pi-alert
		[text]="AlertConstants.EXT_PARTNER_PORTFOLIO_SUBSTITUTION_TEXT | dcr : 'ALERT_EXT_PARTNER_PORTFOLIO_SUBSTITUTION_TEXT'"
		[infoBubble]="alertExtSubstitutionsInfoBubble"
	>
	</pi-alert>
</section>
